import { t } from "@web-monorepo/i18n/macro";
import { getImageSrc } from "@web-monorepo/static-assets";
import { DescriptionSlide } from "src/pods/conundrums/components/DescriptionSlide";
import { IntroSlide } from "src/pods/conundrums/components/IntroSlide";
import { PairShareSlide } from "src/pods/conundrums/components/PairShareSlide";
import { ShareToStorySlide } from "src/pods/conundrums/components/ShareToStorySlide";
import { Slide } from "src/pods/conundrums/components/types";

const introFoods = getImageSrc("toolkit/src/pods/conundrums/assets/introFoods@2x.jpg");
const introMain = getImageSrc("toolkit/src/pods/conundrums/assets/introFoodsEmpty@2x.jpg");
const introFoodsEmpty = getImageSrc("toolkit/src/pods/conundrums/assets/introFoodsEmpty@2x.jpg");
const mojoConundrumHero = getImageSrc("toolkit/src/pods/conundrums/assets/mojoConundrumHero.svg");

export const getTitle = () => t`Intro Conundrum`;
export const getDescription = () =>
  t`What is a conundrum? Teach your students by presenting them with a difficult choice`;

const activities: Slide[] = [
  IntroSlide(getTitle, getDescription, "", introMain, "5-10"),
  DescriptionSlide(
    () => t`A conundrum is a question that is hard to answer. Often, there is no right answer!`,
    mojoConundrumHero,
  ),
  DescriptionSlide(() => t`Write down your two favorite foods. It can be anything!`, introFoods),
  DescriptionSlide(
    () => t`One of these foods you will never eat again… which would you choose? Why?`,
    introFoodsEmpty,
    () => t`I'd never eat _____ again because...`,
  ),
  PairShareSlide(() => t`Was it hard to choose? Why or why not?\nWhat else did you notice?`),
  ShareToStorySlide(
    () => t`Congrats on completing this Conundrum!`,
    () => t`Now that was an interesting question indeed.`,
    "https://static.classdojo.com/img/introConundrumShare.png",
    () => t`Great discussion!`,
  ),
];

export default activities;
